import { isNil } from 'ramda';
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import SelectGroup from '~/components/molecule/SelectGroup';
import AppEntryItemHeader from '~/components/page/Apps/components/AppEntryItemHeader';

import { Device, StepName, InitialState } from './types';
import PreviewContainer from './components/PreviewContainer';
import type { Biedwijzer_AppConfig } from './types';
import type { BiedwijzerAppStatus } from '../..';

export type Props = {
  step: StepName;
  values: BiedwijzerAppStatus['content'] | null;
  data?: {
    appConfigData?: Partial<Biedwijzer_AppConfig>;
    initialState?: Partial<InitialState>;
  } | null;
};

const MainPreview: React.FCC<Props> = ({ dataTestId, step, data, ...rest }) => {
  const options = [
    {
      value: 'desktop' as Device,
      label: 'Desktop',
    },
    {
      value: 'mobile' as Device,
      label: 'Mobile',
    },
  ];

  const [deviceIndex, setDeviceIndex] = useState(0);
  const device = options[deviceIndex].value;

  return (
    <Container>
      <Header>
        <AppEntryItemHeader>Preview</AppEntryItemHeader>
        <SelectGroup
          selectedIndex={deviceIndex}
          onChange={({ selectedOptionIdx }) => {
            if (isNil(selectedOptionIdx)) return;

            setDeviceIndex(selectedOptionIdx);
          }}
          options={options}
        />
      </Header>

      <PreviewContainer
        data-testid={dataTestId}
        previews={[{ device, step }]}
        data={data ?? null}
        {...rest}
      />
    </Container>
  );
};

const Container = styled.div<{}>(() => css``);
const Header = styled.div<{}>(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    padding: ${theme.space('m')} 0;
  `,
);

export default MainPreview;
